import { connect } from 'react-redux';
import DashboardView from './dashboard_view';
import { getCurrentUser } from '../../../reducer';
import {} from '../../../solve/actions';

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
});

const mapDispatchToProps = {};

const DashboardContainer = connect(mapStateToProps, mapDispatchToProps)(DashboardView);

export default DashboardContainer;
